import { Card, CardProps, styled } from "@mui/material";

interface ContentCardProps extends CardProps {
  children: React.ReactNode;
}

const CardStyles = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(3),
  border: "1px solid lightgray",
  backgroundColor: theme.palette.form.background,
}));

const ContentCard = ({ children, ...props }: ContentCardProps) => {
  return (
    <CardStyles elevation={0} {...props}>
      {children}
    </CardStyles>
  );
};

export default ContentCard;
